module.exports = __webpack_public_path__ + "media/images/rank_01-f5c7776813d69d8802687b02d4e01ed2.png";